(function ($) {
  // Add event handler
  $('.pdf-item').on('click', function (e) {
    e.preventDefault();

    const $item = $(e.currentTarget);
    const title = $item.find('.pdf-item_title').text();
    const description = $item.find('.pdf-item_description').html();
    const link = $item.find('.pdf-item_link').attr('href');

    // const $modal = $(e.currentTarget).find('.modal').clone();
    const modal = `
      <div class="modal fade">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h3 class="modal-title">${title}</h3>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                  </div>
                  <div class="modal-body">
                    ${description}
                  </div>
                  <div class="modal-footer flex space-between">
                      <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">Schließen</button>
                      <a href="${link}" target="_blank" class="btn btn-primary">PDF ansehen</a>
                  </div>
              </div>
          </div>
      </div>
    `;

    const $modal = $(modal);

    $('body').append($modal);
    $modal.modal();

    $modal.on('hidden.bs.modal', function (e) {
      $modal.remove();
    });
  });
})(jQuery);



// WEBPACK FOOTER //
// ./grails-app/assetsSrc/scripts/current_information.js